'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useMemo } from 'react';

export function ReactQueryProvider({ children }: { readonly children: React.ReactNode; }) {
	const queryClient = useMemo(() => new QueryClient({
		defaultOptions: {
			queries: {
				staleTime: 60 * 60 * 1000, // 1 hour (as requested for CMS data)
				retry: (failureCount, error) => {
					// Don't retry on 4xx errors except 408, 429
					if (error instanceof Error && 'status' in error) {
						const status = error.status as number;
						if (status >= 400 && status < 500 && status !== 408 && status !== 429) return false;
					}
					return failureCount < 3;
				},
			},
		},
	}), []);

	return <QueryClientProvider client={queryClient}>
		{children}
		<ReactQueryDevtools initialIsOpen={false} />
	</QueryClientProvider>;
}
